export enum TutorialViews {
    TakePhoto,
    HowToOrganize,
    HowToPhotograph,
}
